import {
  Component, OnInit, Inject, ContentChild,
  TemplateRef, Output, EventEmitter, Input, ViewChild, ElementRef
} from '@angular/core';
import {
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-modal-input',
  templateUrl: './modal-input.component.html',
  styleUrls: ['./modal-input.component.scss']
})
export class ModalInputComponent implements OnInit {

  @ContentChild(TemplateRef) template: TemplateRef<MatFormField>;
  @Input() inLabel: string;
  @Input() inValue: string;
  @Input() readonly: boolean;
  @Input() inF: any;
  @Output() outValue = new EventEmitter<string>();
  backup: string;

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
    this.backup = this.inValue;
    // console.log(this.inValue);
  }

  openDialog(): void {
    if (!this.readonly) {
      const dialogRef = this.dialog.open(ModalInputDialogComponent, {
        data: { template: this.template, form: this.inF }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.outValue.emit(result);

      });
    }
  }

}

@Component({
  selector: 'app-modal-input-dialog',
  templateUrl: 'modal-input-dialog.component.html',
})
export class ModalInputDialogComponent implements OnInit {

  template: TemplateRef<MatFormField>;
  formControl: FormControl;

  constructor(
    public dialogRef: MatDialogRef<ModalInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.template = this.data.template;
    this.formControl = this.data.form;
  }

  ngOnInit() {
  }

  onSubmit(): void {
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    if (this.formControl.valid) {
      this.dialogRef.close(true);
    }
  }

}
